export default {

  badge: "Support & Contact",
  title: "Get in Touch",
  subtitle: "For technical support, payment inquiries, or course details, feel free to send us a message.",
  formHeaderTitle: "Send a Message",
  formHeaderSub: "We usually respond within a few hours.",
  fullNameLabel: "Full Name",
  fullNamePlaceholder: "e.g. John Doe",
  phoneLabel: "Phone Number",
  phonePlaceholder: "+1 234 567 8900",
  subjectLabel: "Subject",
  subjects: {
    support: "Technical Support & Course Access",
    payment: "Billing & Payment Inquiries",
    courses: "Course Advisory & Consultation",
    other: "General Questions & Feedback",
  },
  messageLabel: "Your Message",
  messagePlaceholder: "Write your inquiry in detail...",
  submitBtn: "Send Message",
  sendingBtn: "Sending...",
  quickInfoTitle: "Quick Contact Info",
  addressTitle: "Main Office",
  addressVal: "No. 256, Corner of Ravanmehr St., 12 Farvardin St., Enghelab St., Tehran",
  phoneTitle: "Phone Support",
  hoursTitle: "Working Hours",
  hoursVal: "Sat - Wed: 9:00 AM - 6:00 PM",

};
